import React from 'react';
import styled from 'styled-components';

const RadioButton = styled.div<{ size: string }>`
  border: 1px solid #5c6ef8;
  width: ${(props) => props.size};
  height: ${(props) => props.size};
  display: flex;
  border-radius: 30px;
  justify-content: center;
  align-items: center;
`;
const InnerCircle = styled.div<{ visible: boolean }>`
  width: calc(100% - 2px);
  height: calc(100% - 2px);
  background: #5c6ef8;
  border-radius: 100%;
  opacity: ${(props) => (props.visible ? '1' : '0')};
  transition: all 0.1s;
`;

type Props = {
  selected?: boolean;
  color?: string;
  size?: string;
  onClick?: (selected: boolean) => void;
};

function Radio({ selected, color, size = '14px', onClick }: Props) {
  return (
    <RadioButton
      size={size}
      onClick={() => {
        if (onClick) onClick(!!selected);
      }}
    >
      <InnerCircle visible={!!selected} />
    </RadioButton>
  );
}

export default Radio;
